import { typography } from '@shared/tokens/typography.stylex';
import { anatomy } from '@shared/tokens/anatomy.stylex';
import { palette } from '@shared/tokens/palette.stylex';
import { fonts } from '@shared/tokens/fonts.stylex';
import * as stylex from '@stylexjs/stylex';

const inviteColors = {
  background: palette['grey-50'],
  primaryText: palette['grey-950'],
  secondaryText: palette['grey-700'],
  tertiaryText: palette['grey-500'],
  accentText: palette['bronze-500'],
};

export const styles = stylex.create({
  container: {
    background: inviteColors.background,
    fontFamily: fonts.din2014Regular,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    padding: {
      default: '64px 0 0',
      '@media (max-width: 767px)': ' 32px 16px',
    },
    minHeight: '100vh',
  },
  content: {
    flex: '1',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    padding: '40px 0',
    ':not(#__unused__) > button': {
      color: palette.greyWhite,
      height: 'auto',
      fontSize: {
        default: '18px',
        '@media (max-width: 767px)': '14px',
      },
      padding: {
        default: '12px 24px',
        '@media (max-width: 767px)': '8px 20px',
      },
    },
  },

  statusIllustration: {
    width: {
      default: '220px',
      '@media (max-width: 767px)': '160px',
    },
    height: {
      default: '221px',
      '@media (max-width: 767px)': '160px',
    },
    marginBottom: '40px',
    objectFit: 'contain',
  },
  titleInfo: {
    color: inviteColors.primaryText,
    fontWeight: typography.fontWeighDemi,
    lineHeight: {
      default: anatomy['size-40'],
      '@media (max-width: 767px)': anatomy['size-36'],
    },
    fontSize: {
      default: anatomy['size-32'],
      '@media (max-width: 767px)': anatomy['size-28'],
    },
  },
  date: {
    color: inviteColors.secondaryText,
    fontWeight: typography.fontWeighRegular,
    fontSize: {
      default: '18px',
      '@media (max-width: 767px)': '16px',
    },
    lineHeight: {
      default: anatomy['size-24'],
      '@media (max-width: 767px)': anatomy['size-20'],
    },
  },
  subTitleInfo: {
    color: inviteColors.tertiaryText,
    fontWeight: typography.fontWeighRegular,
    marginTop: '8px',
    fontSize: {
      default: '18px',
      '@media (max-width: 767px)': anatomy['size-16'],
    },
    lineHeight: {
      default: anatomy['size-24'],
      '@media (max-width: 767px)': anatomy['size-20'],
    },
  },

  title: {
    color: inviteColors.primaryText,
    fontFamily: fonts.din2014Demi,
    lineHeight: {
      default: anatomy['size-40'],
      '@media (max-width: 767px)': anatomy['size-36'],
    },
    fontSize: {
      default: anatomy['size-32'],
      '@media (max-width: 767px)': anatomy['size-28'],
    },
  },
  actionsRow: {
    display: 'flex',
    gap: '12px',
    justifyContent: 'center',
    marginTop: '24px',
  },
  titleStatus: {
    color: inviteColors.secondaryText,
    fontWeight: typography.fontWeighRegular,
    fontSize: '18px',
    lineHeight: anatomy['size-24'],
  },
  titleStatusBlock: {
    padding: '12px 0 24px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  titleContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
  },
  infoText: {
    display: 'flex',
    color: inviteColors.primaryText,
    fontFamily: fonts.din2014Regular,
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: typography.fontWeighRegular,
    lineHeight: typography['lineHeightBody-3'],
    gap: '10px',
  },
  infoLink: {
    color: inviteColors.accentText,
    textDecorationLine: 'underline',
  },
});
